<div *ngIf="havePermission">
    <div *ngIf="havePermissionWrite">
        <app-roles-configuration-form (saveNewRole)="getSaveNewRole($event)"></app-roles-configuration-form>
    </div>
    <div *ngIf="havePermissionRead">
        <app-roles-configuration-matrix [updateMatrixNewRole]="saveNewRole" [havePermissionWrite]="havePermissionWrite"></app-roles-configuration-matrix>
    </div>
</div>
